OE.addPlugin('Popup', (function(){

    var Plugin = {},
        Options = {
        },
        class_prefix = 'popup',
        overlay_id = class_prefix + '__overlay',

        scrollTimeout = null,
        scrollThreshold = 2,

        dataAttribute = 'data-oe-popup';

    Plugin.init = function()
    {
        initPopUp();
    };

    var initPopUp = function(element)
    {
        if(typeof element === 'undefined')
        {
            var elements = OE.$doc.querySelectorAll('[' + dataAttribute + ']'),
                element_count = elements.length;

            for(var i = 0; i < element_count; i++)
            {
                initPopUp(elements[i]);
            }
        }
        else
        {
            element.addEventListener('click', Plugin.displayPopup);
        }
    };

    Plugin.displayPopup = function(e)
    {
        var is_event = e instanceof Event,
            element = is_event ? this : e;

        if(element)
        {
            if(is_event)
            {
                e.preventDefault();
            }

            var overlay = createOverlay(
                loadContent.bind(element)
            );
        }
    };

    var loadContent = function(overlay)
    {
        var load_type = this.getAttribute(dataAttribute).match(/^(ajax|iframe)$/i) ? this.getAttribute(dataAttribute).toLowerCase() : 'iframe',
            src = this.hasAttribute(dataAttribute+'-src') ? this.hasAttribute(dataAttribute+'-src') : this.getAttribute('href'),
            html = null,
            content_wrapper = overlay.querySelector(_classname('content', '.')),
            content;

        try {
            html = JSON.parse(this.getAttribute(dataAttribute));
        }
        catch(ev)
        {
            html = null;
        }

        if( !html ) {
            try {
                html = document.querySelector( this.getAttribute(dataAttribute) ).outerHTML;
            }
            catch(ev)
            {
                html = null;
            }
        }

        if(html)
        {
            load_type = 'html';
            src = html;
        }

        if(src && content_wrapper)
        {
            overlay.classList.add('is--loading');
            if(this.className)
            {
                overlay.className+= ' ' + this.className;
            }

            if(load_type === 'iframe')
            {
                content = OE.$doc.createElement('iframe');
                content.setAttribute('src', src);

                content.addEventListener('load', function(e){
                    this.classList.remove('is--loading');
                }.bind(overlay));

                content_wrapper.appendChild(content);
            }
            else if(load_type === 'html')
            {
                content = OE.$doc.createElement('div');
                content.classList.add(_classname('customhtml'));
                content.innerHTML = src;
                overlay.classList.remove('is--loading');

                content_wrapper.appendChild(content);
            }
            else if(load_type === 'ajax')
            {
                OE.Plugins.Ajax.request(src, {
                    onSuccess : function(request)
                    {
                        var content_wrapper = this.querySelector(_classname('content', '.')),
                            xmldoc, parser, destination_postlist,
                            html = request.responseText;


                        parser = new DOMParser();
                        xmlDoc = parser.parseFromString(html, "text/html");
                        html = xmlDoc.querySelector('.main > article');

                        if(html)
                        {
                            content_wrapper.appendChild(html);
                        }

                        this.classList.remove('is--loading');
                    }.bind(overlay)
                });
            }
        }
    };



    var _classname = function(suffix, prefix)
    {
        prefix = typeof(prefix) === 'string' ? prefix : '';
        return prefix + class_prefix + (suffix && typeof(suffix) === 'string' ? '__' + suffix : '');
    };

    var createOverlay = function(onLoadFunction, onCloseFunction)
    {
        var overlay = OE.$doc.querySelector(_classname('overlay', '.')),
            close, content_wrapper, content_div;

        if(!overlay)
        {
            overlay = OE.$doc.createElement('div');
            overlay.classList.add(_classname('overlay'));
            overlay.classList.add('is--active');

            OE.$doc.querySelector('body').appendChild(overlay);

            content_wrapper = OE.$doc.createElement('div');
            content_wrapper.classList.add(_classname('content-wrapper'));
            overlay.appendChild(content_wrapper);

            close = OE.$doc.createElement('span');
            close.textContent = '';
            close.classList.add(_classname('close'));
            close.addEventListener(OE.CLICK, closeOverlay.bind(overlay, onCloseFunction));
            content_wrapper.appendChild(close);

            content_div = OE.$doc.createElement('div');
            content_div.classList.add(_classname('content'));
            content_wrapper.appendChild(content_div);

            window.addEventListener('keyup', listen_on_esc);

            overlay.classList.add('is--active');
        }

        if(typeof onLoadFunction === 'function')
        {
            onLoadFunction(overlay);
        }

        return overlay;
    };

    var closeOverlay = function(onCloseFunction, e)
    {
        var overlay = OE.$doc.querySelector(_classname('overlay', '.')),
            transition;

        if(overlay)
        {
            transition = getOverlayTransition(overlay);
            if(transition)
            {
                overlay.addEventListener(transition, removeOverlay.bind(overlay, onCloseFunction), false);
                overlay.classList.remove('is--active');
            }
            else
            {
                removeOverlay.bind(overlay, onCloseFunction)();
            }

            overlay.classList.remove('is--active');

            window.removeEventListener('keyup', listen_on_esc);
        }
    };

    var getOverlayTransition = function(overlay)
    {
        if(overlay)
        {
            var transitions = {
                    'transition':'transitionend',
                    'OTransition':'oTransitionEnd',
                    'MozTransition':'transitionend',
                    'WebkitTransition':'webkitTransitionEnd'
                },
                transition = null,
                durations = {
                    'transitionDuration':'transitionduration',
                    'OTransitionDuration':'oTransitionDuration',
                    'MozTransitionDuration':'transitionduration',
                    'WebkitTransitionDuration':'webkitTransitionDuration'
                };

            for(var t in transitions)
            {
                if( overlay.style[t] !== undefined )
                {
                    transition =  transitions[t];
                    break;
                }
            }

            if(transition)
            {
                for(var u in durations)
                {
                    if( overlay.style[u] !== undefined )
                    {
                        if(parseInt(overlay.style[u]) > 0)
                        {
                            return transition;
                        }
                        break;
                    }
                }
            }
        }

        return null;
    };

    var removeOverlay = function(onCloseFunction, e)
    {
        var overlay = this;
        if(overlay)
        {
            if(typeof onCloseFunction === 'function')
            {
                onCloseFunction();
            }
            overlay.parentElement.removeChild(overlay);
        }
    };

    var listen_on_esc = function(e)
    {
        if(e.keyCode === 27)
        {
            var close_button = OE.$doc.querySelector(_classname('overlay', '.') + ' ' + _classname('close', '.'));

            if(close_button)
            {
                OE.Utils.triggerEvent(close_button, OE.CLICK);
            }
            else
            {
                closeOverlay();
            }
        }
    };

    return Plugin;
})());
